




// types
import { Component, Vue } from 'vue-property-decorator'
import HttpResponseException from '~/exceptions/http/HttpResponseException'
import { useUserLookupPort } from '~/platform/user/UserPortsAdapter'

// utils
import { parseGalleryIdOrNotFound } from '~/utils/gallery/parseGalleryIdOrNotFound'
import { setDiaryUserIfNotExists, hasDiaryUser } from '~/utils/user'

// components
import GalleryPageUniversal from '~/components/forSpecificPage/gallery/GalleryPageUniversal.vue'

@Component({
  head () {
    const galleryName = this.$storeModules.gallery.currentGallery
      ? this.$storeModules.gallery.currentGallery.name
      : ''
    const fio = this.$storeModules.diary.currentUser
      ? this.$storeModules.diary.currentUser.fio
      : ''

    return {
      title: `Фотоальбом "${galleryName}" от пользователя ${fio}`
    }
  },
  components: {
    GalleryPageUniversal
  },
  scrollToTop: true,
  async asyncData (ctx) {
    const { $storeModules, params, error } = ctx
    const { galleryId, notFoundResult } = parseGalleryIdOrNotFound(params.galleryId, error)

    if (galleryId === null) {
      return notFoundResult
    }

    let galleryAuthor

    try {
      const [userResponse] = await Promise.all([
        useUserLookupPort().getByLogin(params.userLogin),
        $storeModules.gallery.fetchGallery({
          id: galleryId,
          authorLogin: params.userLogin
        })
      ])
      galleryAuthor = userResponse.user

      $storeModules.gallery.setCurrentAuthor(galleryAuthor)
      $storeModules.gallery.setCurrentCommunity(null)
    } catch (e) {
      if (e instanceof HttpResponseException) {
        if (e.code === 403) {
          return error({
            statusCode: 403,
            message: 'Доступ запрещён'
          })
        }
      }

      throw e
    }

    if (!$storeModules.gallery.currentGallery) {
      // Хелпер сам завершает запрос, если владельца дневника нет: 301 на новый логин,
      // иначе 404/410. Свой redirect поверх перекрыл бы этот ответ — Nuxt проверяет
      // ssrContext.redirected раньше nuxt.error.
      const missingUserResult = await setDiaryUserIfNotExists(ctx)

      if (!hasDiaryUser($storeModules)) {
        return missingUserResult
      }

      // SEO: владелец дневника жив, а альбома нет — отдаём статус самого альбома,
      // а не 301 на профиль. Редирект на живой профиль означал бы для URL альбома
      // ответ 200 чужим контентом, и поисковик держал бы адрес в индексе.
      return error({
        statusCode: 404,
        message: 'Фотоальбом не найден'
      })
    }
  }
})
export default class GalleryDiaryPage extends Vue {}
